


















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import FormPlainSelect from '~/components/partials/Form/FormPlainSelect.vue';
import { usePropSync } from '~/composables/usePropSync';

export type SortOption = {
  label: string;
  target: string | number | null;
  order?: string | null;
  index?: number;
};

export default defineComponent({
  components: {
    AppIcon,
    FormPlainSelect,
  },
  props: {
    options: {
      type: Array as PropType<SortOption[]>,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    isProductSearchHeader: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { syncedCurrentIndex } = usePropSync(props, 'currentIndex');

    return {
      syncedCurrentIndex,
    };
  },
});
